import { Navigate } from "react-router-dom";

export default function PublicRoute({ element }) {
  return localStorage.getItem('tokenme') ? (
    <Navigate to="/" replace />
  ) : (
    element
  );
}